<template>
	<v-expansion-panels
		v-if="nodes && nodes.length"
		id="bee-expander-tree"
		accordion
		flat
		tile
	>
		<bee-expander-tree-node
			v-for="(child, i) in nodes"
			:key="child.id"
			:item-text="itemText"
			:item-class="itemClass"
			:node="child"
			:level="level"
			:showDivider="i !== nodes.length -1"
			:disabled-buttons="disabledButtons"
			@select-item="e => $emit('select-item', e)"
		/>
	</v-expansion-panels>
</template>

<script>
import BeeExpanderTreeNode from './BeeExpanderTreeNode.vue';
export default {
	name: 'VTree',
	props: {
		nodes: { type: Array },
		level: { type: Number, default: 1 },
		itemClass: { type: String, default: 'name' },
		showDivider: { type: Boolean, default: false },
		disabledButtons: { type: Boolean, default: false },
		itemText: { type: [String, Function], default: 'name' },
	},
	components: { BeeExpanderTreeNode },
};
</script>

<style lang="scss">
#bee-expander-tree {
	.v-expansion-panel-header {
		padding: 0 6px;
	}
	.v-expansion-panel-content__wrap {
		padding: 0;
	}
}
</style>